export default __webpack_public_path__ + "static/media/play-icon.9637bf38.svg";